import { render, staticRenderFns } from "./highlightincorrectword.vue?vue&type=template&id=27bc1f52&scoped=true&"
import script from "./highlightincorrectword.vue?vue&type=script&lang=js&"
export * from "./highlightincorrectword.vue?vue&type=script&lang=js&"
import style0 from "./highlightincorrectword.vue?vue&type=style&index=0&id=27bc1f52&scoped=true&lang=css&"
import style1 from "./highlightincorrectword.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc1f52",
  null
  
)

export default component.exports